import useTestId from '@ori/testid-generator';
import { Brand, ImageWrapper, Name, NamesWrapper, Ppa, ProductBoxRoot } from "./styles";
import { IconButtons, PointsOrDealLabel, PricesSection, ProductImage, Rating, Shades } from "../components";
import { useOnClick, useProduct } from "../hooks/internal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InnerProductBox = function InnerProductBox() {
  var _labels$ppa;
  var onClick = useOnClick();
  var _useProduct = useProduct(),
    brand = _useProduct.brand,
    className = _useProduct.className,
    code = _useProduct.code,
    labels = _useProduct.labels,
    name = _useProduct.name,
    url = _useProduct.url;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _ref = (_labels$ppa = labels === null || labels === void 0 ? void 0 : labels.ppa) !== null && _labels$ppa !== void 0 ? _labels$ppa : {},
    _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? null : _ref$labelKey,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? null : _ref$title;
  return /*#__PURE__*/_jsxs(ProductBoxRoot, {
    className: className,
    href: url,
    "data-testid": getTestId(code),
    onClick: onClick,
    children: [/*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs(ImageWrapper, {
        children: [/*#__PURE__*/_jsx(ProductImage, {}), /*#__PURE__*/_jsx(PointsOrDealLabel, {}), /*#__PURE__*/_jsx(IconButtons, {})]
      }), /*#__PURE__*/_jsx(Ppa, {
        shouldRenderEmptyLabel: true,
        label: title,
        productCode: code,
        size: "small",
        type: labelKey
      })]
    }), /*#__PURE__*/_jsx(Rating, {}), /*#__PURE__*/_jsxs(NamesWrapper, {
      children: [/*#__PURE__*/_jsx(Brand, {
        "data-testid": "".concat(getTestId('brand'), "-").concat(code),
        children: brand !== null && brand !== void 0 ? brand : ''
      }), /*#__PURE__*/_jsx(Name, {
        "data-testid": "".concat(getTestId('name'), "-").concat(code),
        children: name
      })]
    }), /*#__PURE__*/_jsx(Shades, {}), /*#__PURE__*/_jsx(PricesSection, {})]
  });
};
//# sourceMappingURL=InnerProductBox.js.map